import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f458ed0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "circle-buttons d-flex" }
const _hoisted_2 = { class: "circle-buttons d-flex" }
const _hoisted_3 = { class: "base-buttons d-flex" }
const _hoisted_4 = { class: "base-buttons d-flex nav" }
const _hoisted_5 = { class: "base-buttons large d-flex" }
const _hoisted_6 = { class: "base-headers test-header" }
const _hoisted_7 = { class: "circle-buttons player d-flex" }
const _hoisted_8 = { class: "details" }

import CircleButton from '@/components/Buttons/CircleButton.vue'
import BaseButton from '@/components/Buttons/BaseButton.vue'
import IconBase from '@/components/Icons/IconBase.vue'
import BaseHeader from '@/components/Headers/BaseHeader.vue'
import DetailTest from '@/components/DetailTest.vue'
import AD from '@/components/AD.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'UIView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(CircleButton, {
        name: "like",
        iconWidth: 18,
        iconHeight: 15.96,
        "view-box": "0 0 18 15.96"
      }),
      _createVNode(CircleButton, {
        name: "star",
        iconWidth: 19.65,
        iconHeight: 18.74,
        "view-box": "0 0 19.65 18.74"
      }),
      _createVNode(CircleButton, {
        name: "comment",
        iconWidth: 18,
        iconHeight: 18,
        "view-box": "0 0 18 18"
      }),
      _createVNode(CircleButton, {
        name: "upload",
        iconWidth: 16,
        iconHeight: 18,
        "view-box": "0 0 16 18"
      }),
      _createVNode(CircleButton, {
        name: "message",
        iconWidth: 17.79,
        iconHeight: 17.79,
        "view-box": "0 0 17.79 17.79"
      }),
      _createVNode(CircleButton, {
        name: "mute",
        bg: "none",
        iconWidth: 16,
        iconHeight: 18,
        "view-box": "0 0 16 18"
      }),
      _createVNode(CircleButton, {
        name: "arrow-right",
        iconWidth: 18,
        iconHeight: 16,
        "view-box": "0 0 18 16"
      }),
      _createVNode(CircleButton, {
        name: "resize-full",
        iconWidth: 18,
        iconHeight: 18,
        "view-box": "0 0 18 18"
      }),
      _createVNode(CircleButton, {
        name: "chevron-right",
        bg: "empty",
        iconWidth: 15,
        iconHeight: 30,
        "view-box": "0 0 15 30"
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(CircleButton, {
        name: "like",
        bg: "gradient",
        iconWidth: 18,
        iconHeight: 15.96,
        "view-box": "0 0 18 15.96"
      }),
      _createVNode(CircleButton, {
        name: "star",
        bg: "gradient",
        iconWidth: 19.65,
        iconHeight: 18.74,
        "view-box": "0 0 19.65 18.74"
      }),
      _createVNode(CircleButton, {
        name: "comment",
        bg: "gradient",
        iconWidth: 18,
        iconHeight: 18,
        "view-box": "0 0 18 18"
      }),
      _createVNode(CircleButton, {
        name: "upload",
        bg: "gradient",
        iconWidth: 16,
        iconHeight: 18,
        "view-box": "0 0 16 18"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(BaseButton, {
        class: "uppercase",
        bg: "none",
        border: "default"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Серия 1")
        ]),
        _: 1
      }),
      _createVNode(BaseButton, {
        class: "uppercase",
        bg: "none",
        border: "gradient"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Серия 1")
        ]),
        _: 1
      }),
      _createVNode(BaseButton, {
        class: "uppercase",
        disabled: ""
      }, {
        default: _withCtx(() => [
          _createTextVNode("Серия 1")
        ]),
        _: 1
      }),
      _createVNode(BaseButton, {
        class: "uppercase",
        bg: "gradient"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Серия 1")
        ]),
        _: 1
      }),
      _createVNode(BaseButton, {
        class: "uppercase",
        bg: "none",
        border: "gradient",
        color: "gradient"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Серия 1")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(BaseButton, {
        class: "uppercase",
        bg: "none",
        border: "gradient"
      }, {
        default: _withCtx(() => [
          _createVNode(IconBase, {
            name: "chevron-right",
            "view-box": "0 0 12 15",
            width: 12,
            height: 15
          })
        ]),
        _: 1
      }),
      _createVNode(BaseButton, {
        class: "uppercase",
        bg: "none",
        border: "gradient"
      }, {
        default: _withCtx(() => [
          _createTextVNode("2")
        ]),
        _: 1
      }),
      _createVNode(BaseButton, {
        class: "uppercase",
        bg: "none",
        border: "gradient"
      }, {
        default: _withCtx(() => [
          _createTextVNode("3")
        ]),
        _: 1
      }),
      _createVNode(BaseButton, {
        class: "uppercase",
        bg: "none",
        border: "gradient"
      }, {
        default: _withCtx(() => [
          _createTextVNode("4")
        ]),
        _: 1
      }),
      _createVNode(BaseButton, {
        class: "uppercase",
        bg: "none",
        border: "gradient"
      }, {
        default: _withCtx(() => [
          _createTextVNode("22")
        ]),
        _: 1
      }),
      _createVNode(BaseButton, {
        class: "uppercase",
        bg: "none",
        border: "gradient"
      }, {
        default: _withCtx(() => [
          _createTextVNode("42")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(BaseButton, {
        class: "large rounded",
        bg: "none",
        border: "gradient",
        color: "gradient"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Зарегистрироваться")
        ]),
        _: 1
      }),
      _createVNode(BaseButton, {
        class: "large rounded",
        bg: "none",
        border: "default"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Зарегистрироваться")
        ]),
        _: 1
      }),
      _createVNode(BaseButton, {
        class: "large rounded",
        disabled: ""
      }, {
        default: _withCtx(() => [
          _createTextVNode("Зарегистрироваться")
        ]),
        _: 1
      }),
      _createVNode(BaseButton, {
        class: "large rounded test-width",
        bg: "gradient",
        border: "gradient"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Смотреть "),
          _createVNode(IconBase, {
            name: "chevron-right",
            "view-box": "0 0 12 15",
            width: 12,
            height: 15
          })
        ]),
        _: 1
      }),
      _createVNode(BaseButton, {
        class: "large rounded test-width",
        bg: "gradient",
        border: "gradient"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Смотреть "),
          _createVNode(IconBase, {
            name: "upload",
            "view-box": "0 0 16 18",
            width: 16,
            height: 18
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(BaseHeader),
      _createVNode(AD)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(CircleButton, {
        class: "btn-player__action",
        name: "play",
        iconWidth: 47,
        iconHeight: 47,
        "view-box": "0 0 28.58 39.49"
      }),
      _createVNode(CircleButton, {
        class: "btn-player__action",
        name: "pause",
        iconWidth: 24,
        iconHeight: 40,
        "view-box": "0 0 24 40"
      }),
      _createVNode(CircleButton, {
        class: "btn-player",
        name: "lock",
        iconWidth: 48.32,
        iconHeight: 60.4,
        "view-box": "0 0 48.32 60.4"
      })
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(DetailTest, { class: "test-detail" })
    ])
  ], 64))
}
}

})